import { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Flex, Box } from "@chakra-ui/react";
import { compose } from "recompose";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { withPurchase } from "src/modules/purchase/PurchaseContext";
import ListButton from "src/components/ListButton";
import NavigationBar from "src/components/NavigationBar";
import SoundAlertsSettings from "src/modules/sound-alerts/SoundAlertsSettings/";
import VideoSettings from "src/components/VideoSettings";
import EventSettings from "src/components/EventsSettings";
import ThemeSettings from "./components/ThemeSettings";

import { ReactComponent as DarkmodeOutlined } from "./icons/darkmode-outlined.svg";
import { ReactComponent as SoundOutlined } from "./icons/sound-outlined.svg";
import { ReactComponent as VideoOutlined } from "./icons/video-outlined.svg";
import { ReactComponent as EventsOutlined } from "./icons/events-outlined.svg";
import { AnimatePresence } from "framer-motion";
import SceneAnimation from "src/components/SceneAnimation";

class General extends Component {
  state = {
    OpenedFlow: null,
    renderTheme: false,
    flowDirection: "next"
  };

  openFlow = (Flow) =>
    this.setState({ flowDirection: "next" }, () =>
      this.setState({ OpenedFlow: Flow })
    );
  closeFlow = () =>
    this.setState({ flowDirection: "previous" }, () =>
      this.setState({ OpenedFlow: null })
    );

  openTheme = () => this.setState({ renderTheme: true });
  closeTheme = () => this.setState({ renderTheme: false });

  render() {
    const { OpenedFlow, renderTheme, flowDirection } = this.state;
    const { onClose, onBack, isFreeVersion, purchase } = this.props;

    return (
      <AnimatePresence initial={false}>
        {OpenedFlow ? (
          <SceneAnimation key="deepFlow" direction={flowDirection}>
            <OpenedFlow onClose={onClose} onBack={this.closeFlow} />
          </SceneAnimation>
        ) : (
          <SceneAnimation key="general" direction={flowDirection}>
            <ThemeSettings isOpen={renderTheme} onClose={this.closeTheme} />
            <NavigationBar
              headingKey="parentStation.settings.general.heading"
              onClose={onClose}
              onBack={onBack}
            />

            <Flex flexWrap="wrap" mt="16px" mr="-24px" py="8px" px="24px">
              <Box width="50%" pr="24px" mb="16px">
                <ListButton
                  iconFill="primary"
                  width="280px"
                  labelKey="soundAlerts.heading"
                  icon={SoundOutlined}
                  onClick={() => this.openFlow(SoundAlertsSettings)}
                />
              </Box>

              <Box width="50%" pr="24px" mb="16px">
                <ListButton
                  iconFill="primary"
                  width="280px"
                  labelKey="theme.heading"
                  icon={DarkmodeOutlined}
                  onClick={this.openTheme}
                />
              </Box>
              <Box width="50%" pr="24px" mb="16px">
                <ListButton
                  iconFill="primary"
                  width="280px"
                  labelKey="videoSettings.heading"
                  icon={VideoOutlined}
                  onClick={() => this.openFlow(VideoSettings)}
                />
              </Box>
              <Box width="50%" pr="24px" mb="16px">
                <ListButton
                  iconFill="primary"
                  width="280px"
                  labelKey="events.heading"
                  icon={EventsOutlined}
                  onClick={() =>
                    isFreeVersion
                      ? purchase.open({ content: "events" })
                      : this.openFlow(EventSettings)
                  }
                />
              </Box>
            </Flex>
          </SceneAnimation>
        )}
      </AnimatePresence>
    );
  }
}

function mapStateToProps(state) {
  return {
    isFreeVersion: isFreemium(state)
  };
}

const enhance = compose(
  withTranslation(),
  withPurchase,
  connect(mapStateToProps)
);
export default enhance(General);
